import { render, staticRenderFns } from "./mobileMenu.vue?vue&type=template&id=20befba6&scoped=true"
import script from "./mobileMenu.vue?vue&type=script&lang=js"
export * from "./mobileMenu.vue?vue&type=script&lang=js"
import style0 from "./mobileMenu.vue?vue&type=style&index=0&id=20befba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20befba6",
  null
  
)

export default component.exports